import { render, staticRenderFns } from "./DemoEnter.vue?vue&type=template&id=dfaeb6aa&scoped=true"
import script from "./DemoEnter.vue?vue&type=script&lang=js"
export * from "./DemoEnter.vue?vue&type=script&lang=js"
import style0 from "./DemoEnter.vue?vue&type=style&index=0&id=dfaeb6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaeb6aa",
  null
  
)

export default component.exports